import React from "react";
import Icon from "@dtci/spellbook/Icon";
import styles from "./pptStatusLifecycle.module.scss";

/**
 * Custom stepper. Two signals separated:
 *   - position (where we are): structure — current node has dashed-ring halo,
 *     past stages have filled green connectors, future stages have dashed gray.
 *   - health (how we are): color on the current node; past = green; future = gray.
 *
 * Issue counts on the current stage are shown as two adjacent badges (errors
 * then warnings) so triage can read the breakdown without expanding anything.
 */

const NODE_HEALTH_CLASS = {
  inProgress: styles.nodeInProgress,
  warning: styles.nodeCurrentWarning,
  error: styles.nodeCurrentError,
};

export const Stepper = ({
  stages,
  currentStageIndex,
  currentHealth,
  isDone = false,
}) => {
  return (
    <div className={styles.stepper} role="list">
      {stages.map((stage, index) => {
        // When the promo is Done every stage is complete and there is no
        // "current" — the structural ring/halo and status pill should both
        // be suppressed in favor of the finished green check.
        const isCurrent = !isDone && index === currentStageIndex;
        const isPast = isDone || index < currentStageIndex;
        const isFuture = !isDone && index > currentStageIndex;

        const nodeClass = [
          styles.node,
          isPast && styles.nodeComplete,
          isCurrent && styles.nodeCurrent,
          isCurrent && NODE_HEALTH_CLASS[currentHealth],
          isFuture && styles.nodeNotStarted,
        ]
          .filter(Boolean)
          .join(" ");

        const labelClass = [styles.label, isCurrent && styles.labelCurrent]
          .filter(Boolean)
          .join(" ");

        const nextStage = stages[index + 1];
        const connectorClass = [
          styles.connector,
          isPast && styles.connectorComplete,
          (isCurrent || isFuture) && styles.connectorPending,
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <React.Fragment key={stage.id}>
            <div className={styles.stepCol} role="listitem">
              <div className={nodeClass}>
                <div className={styles.nodeIcon}>
                  {isPast ? (
                    <Icon
                      iconType="fa"
                      faPackage="fas"
                      iconName="fa-check"
                      size="small"
                    />
                  ) : (
                    <span>{stage.position}</span>
                  )}
                </div>
                <div className={labelClass}>{stage.name}</div>
              </div>
            </div>
            {nextStage && (
              <div className={connectorClass} aria-hidden="true"></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
